import styled from 'styled-components';

export const ModalHeaderContainer = styled.div`
  display: flex;
`;

export const MessageHeading = styled.p`
  margin-bottom: 0px;
  font-weight: 600;
`;

export const MessageParagraph = styled.p`
  margin-top: 0px;
  padding-bottom: 10px;
`;
